"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = transform;
exports.toSentenceCase = exports.toUpperCase = exports.toLowerCase = exports.toTitleCase = void 0;

var _ToTitleCase = _interopRequireDefault(require("./ToTitleCase"));

var _ToLowerCase = _interopRequireDefault(require("./ToLowerCase"));

var _ToUpperCase = _interopRequireDefault(require("./ToUpperCase"));

var _ToSentenceCase = _interopRequireDefault(require("./ToSentenceCase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Transforms a string using the provided transformers. Transformations are applied in the provided order.
 * @param input
 * @param transformers
 */
function transform(input) {
  for (var _len = arguments.length, transformers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    transformers[_key - 1] = arguments[_key];
  }

  return transformers.reduce(function (curr, transformer) {
    return transformer.transform(curr);
  }, input);
}
/**
 * Changes string to title case
 * @example "INvalid caSEs arE corrected" -> "Invalid Cases Are Corrected"
 */


var toTitleCase = new _ToTitleCase["default"]();
/**
 * Changes the string to lower case
 * @example "Sentence casing" -> "sentence casing"
 */

exports.toTitleCase = toTitleCase;
var toLowerCase = new _ToLowerCase["default"]();
/**
 * Changes the string to upper case
 * @example "lower case statement" -> "LOWER CASE STATEMENT"
 */

exports.toLowerCase = toLowerCase;
var toUpperCase = new _ToUpperCase["default"]();
/**
 * Changes the string to sentence case
 * @example "lower case statement" -> "Lower case statement"
 */

exports.toUpperCase = toUpperCase;
var toSentenceCase = new _ToSentenceCase["default"]();
exports.toSentenceCase = toSentenceCase;